'use client';

import React from 'react';
import FeedbackStar from './FeedbackStar';

type FeedbackStarRatingProps = {
  rating: number | null;
  hoveredRating: number | null;
  onSelect: (rating: number) => void;
  onHover: (rating: number | null) => void;
  interactive?: boolean;
};

const FeedbackStarRating = ({
  rating,
  hoveredRating,
  onSelect,
  onHover,
  interactive = true,
}: FeedbackStarRatingProps) => {
  const activeRating = hoveredRating ?? rating ?? 0;

  return (
    <div
      className="d-flex align-items-center it-feedback-stars"
      role={interactive ? 'radiogroup' : undefined}
      aria-label="Valutazione stelle"
    >
      {[1, 2, 3, 4, 5].map((star) => {
        const isFilled = star <= activeRating;

        if (!interactive) {
          return (
            <span
              key={star}
              className={`it-feedback-star-display${isFilled ? ' is-active' : ''}`}
            >
              <FeedbackStar filled={isFilled} />
            </span>
          );
        }

        return (
          <button
            key={star}
            type="button"
            className={`btn p-0 border-0 rating-stars it-feedback-star-button${
              isFilled ? ' is-active' : ''
            }`}
            aria-label={`Valuta ${star} stelle`}
            aria-pressed={rating === star}
            onClick={() => onSelect(star)}
            onMouseEnter={() => onHover(star)}
            onMouseLeave={() => onHover(null)}
            onFocus={() => onHover(star)}
            onBlur={() => onHover(null)}
          >
            <FeedbackStar filled={isFilled} />
          </button>
        );
      })}
    </div>
  );
};

export default FeedbackStarRating;
